import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'qb-sync-status',
  template: `
    <span class="qb-sync-status" [class]="'qb-sync-status qb-sync-status--' + state"
      [matTooltip]="tooltip" matTooltipPosition="above" [attr.aria-label]="tooltip">
      <span class="qb-sync-status__mark">QB</span>
      <mat-icon *ngIf="state !== 'current'">{{ state === 'stale' ? 'warning' : 'error' }}</mat-icon>
      <span class="qb-sync-status__date">{{ displayDate }}</span>
    </span>
  `,
  styles: [`
    .qb-sync-status {
      align-items: center;
      display: inline-flex;
      gap: 5px;
      white-space: nowrap;
    }

    .qb-sync-status__mark {
      align-items: center;
      border: 2px solid currentColor;
      border-radius: 50%;
      display: inline-flex;
      font-size: 10px;
      font-weight: 700;
      height: 27px;
      justify-content: center;
      line-height: 1;
      width: 27px;
    }

    .qb-sync-status__date {
      color: #4a4f55;
      font-size: 12px;
    }

    .qb-sync-status mat-icon {
      font-size: 18px;
      height: 18px;
      width: 18px;
    }

    .qb-sync-status--current { color: #238636; }
    .qb-sync-status--stale { color: #b36b00; }
    .qb-sync-status--missing { color: #c62828; }
  `]
})
export class QuickBooksSyncStatusComponent implements OnChanges {
  private static readonly StaleAfterDays = 3;

  @Input() contact: any;

  state: 'current' | 'stale' | 'missing' = 'missing';
  displayDate = 'לא סונכרן';
  tooltip = 'איש הקשר עדיין לא סונכרן עם QuickBooks';

  ngOnChanges(): void {
    const quickBooksId = this.contact && this.contact.quickBooksId;
    const lastSyncDate = this.contact && this.contact.lastSyncDate
      ? new Date(this.contact.lastSyncDate)
      : null;

    if (!quickBooksId || !lastSyncDate || isNaN(lastSyncDate.getTime())) {
      this.state = 'missing';
      this.displayDate = 'לא סונכרן';
      this.tooltip = quickBooksId
        ? 'איש הקשר מקושר ל-QuickBooks, אך אין תאריך סנכרון אחרון'
        : 'איש הקשר עדיין לא סונכרן עם QuickBooks';
      return;
    }

    const ageInDays = Math.floor((Date.now() - lastSyncDate.getTime()) / 86400000);
    this.state = ageInDays > QuickBooksSyncStatusComponent.StaleAfterDays ? 'stale' : 'current';
    this.displayDate = lastSyncDate.toLocaleDateString('he-IL');
    this.tooltip = this.state === 'stale'
      ? `הסנכרון האחרון עם QuickBooks היה ב-${lastSyncDate.toLocaleString('he-IL')}. מומלץ לסנכרן שוב.`
      : `סונכרן לאחרונה עם QuickBooks ב-${lastSyncDate.toLocaleString('he-IL')}`;
  }
}
